/* eslint-disable no-shadow */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import {
  IEntityTicketReportData,
  screeningTicketEntityPDF,
} from 'components/Common/EntityTicketPdf';
import { GlobalContext } from 'providers/GlobalProvider';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import CommentOutlinedIcon from '@mui/icons-material/CommentOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import { useRunAndPersistAdverseMedia } from 'api/bitedb/ai/ai.hooks';
import {
  useCreateComment,
  useDeleteComment,
  useGetCommentsByCommentableId,
} from 'api/bitedb/comment/comment.hooks';
import {
  entityKeys,
  useGetEntityById,
  useGetEntityHierarchy,
  useGetEntityOwnershipMatches,
  useEvaluateOwnership,
  useUpdateEntityStatus,
} from 'api/bitedb/entities/entities.hooks';
import { useUpdateProductStatus } from 'api/bitedb/products/products.hooks';
import {
  screeningKeys,
  useGetDatabaseScreeningStatus,
  useGetScreeningHistoryByEntityId,
  useBulkHideEntityHits,
  useBulkUnhideEntityHits,
  useRunDatabaseScreening,
  useRunEntityScreening,
  useToggleEntityDocVisibility,
  useToggleProductDocVisibility,
} from 'api/bitedb/screeningHistory/screening.hooks';
import {
  databaseKeys,
  useGetDatabaseById,
} from 'api/bitedb/database/database.hooks';
import { DELAYED_SCREENING_MESSAGE } from '../NewComponents/DatabaseCard';
import { useQueryClient } from '@tanstack/react-query';
import {
  useEntityTimeline,
  useGetAuditLogActionsByEntityAssociation,
  useGetAuditLogActorsByEntityAssociation,
  useGetAuditLogsByDatabaseIdPaginated,
  useGetAuditLogsByProductIdPaginated,
} from 'api/bitedb/audit/audit.hooks';

import type { DetailsCardHandles } from '../Cards/DetailsCard';
import RelationshipHierarchyPanel from './RelationshipHierarchyPanel';
import RelationshipDetailsPanel from './RelationshipDetailsPanel';
import BiteDBAllMatchesTable from '../Tables/BiteDBAllMatchesTable';
import BiteDBEntityScreeningResults, {
  OWNERSHIP_RESULTS_PAGE_SIZE,
  ResultSource,
} from '../Tables/BiteDBEntityScreeningResults';
import { Drawer, Modal } from '@mui/material';
import pako from 'pako';
import { Buffer } from 'buffer';
import { enqueueSnackbar } from 'notistack';
import LinkProductSupplierModal from '../Modal/LinkProductSupplierModal';
import { getDateDifference } from 'utils/dateFormater';
import ShareModal from './ShareModal';
import ChangeStatus from '../Modal/ChangeStatus';
import ConfirmRelationshipRemovalModal from '../Modal/ConfirmRelationshipRemovalModal';
import { Form, Formik } from 'formik';
import AddEntityRelationshipModal from '../Modal/AddEntityRelationshipModal';
import {
  useDeleteEntityRelationship,
  useGetEntityRelationships,
} from 'api/bitedb/entityRelationships/entityRelationships.hooks';
import Comments from '../UI/Comments';
import AuditLogPanel, {
  AuditActivity,
  AuditFilterChip,
} from 'components/ui/AuditLogPanel';
import { entityRef } from 'api/bitedb/ids';
import { ScopedQuery } from 'api/bitedb/shared';
import {
  EMPTY_AUDIT_LOG_DATABASE_FILTERS,
  hasActiveAuditLogFilters,
  IAuditLogDatabaseFilters,
  IAuditLogPageResponse,
} from 'api/bitedb/audit/audit.d';
import AuditLogFilterModal, {
  auditActorId,
  auditActorLabel,
  formatAuditActionLabel,
} from '../Modal/AuditLogFilterModal';
import moment from 'moment';
import HelpContentModal from './HelpContent';
import { helpContent } from '../common/HelpContent';
import {
  BulkHitSelection,
  BulkHitVisibilityOperation,
  getBulkHitSelectionKey,
} from '../Tables/bulkHitSelection';
import { resolveBeneficialOwnershipEnabled } from 'hooks/useEntityScreeningLenses';
import EntityVerificationBand from './EntityVerificationBand';
import CreditsAPI from 'api/CreditsAPI';
import {
  buildEntityVerificationReportChecks,
  latestVerificationRun,
} from './entityVerificationReportModel';
import { useVerificationRun } from './useVerificationRun';
import {
  describeVerificationResult,
  hasVerificationResults,
  resolveVerificationPageState,
  verificationRunBlockedReason,
} from './verificationReportSummary';
import EntityVerificationReportView from './EntityVerificationReportView';
import EntityHubVerdictBoxes from './EntityHubVerdictBoxes';
import EntityHubStatusTabs, {
  EntityHubStatusTab,
  sectionPanelId,
  sectionTabId,
} from './EntityHubStatusTabs';
import EntityHubDeepDive from './EntityHubDeepDive';
import { useOwnershipInvestigation } from './useOwnershipInvestigation';
import { downloadOwnershipReportPdf } from './ownershipReportPdf';
import { downloadEntityRiskReportPdf } from './entityRiskReportPdf';
import { useEntityRiskEvaluation } from './useEntityRiskEvaluation';
import {
  canReadOwnershipReport,
  deepDiveSectionStatus,
  investigationTool,
  EntityHubSection,
  parseEntityHubSection,
  screeningSectionStatus,
  verificationSectionStatus,
} from './entityHubSections';
import { useEntityLibrary } from './useEntityLibrary';
import {
  hasCompletedOwnershipEvaluation,
  normalizeAdverseMediaEvaluation,
  normalizeOwnershipEvaluation,
} from './entityInsightState';
import {
  getResultsReportDownloadUrl,
  startResultsReport,
} from 'api/bitedb/resultsReport';
import { useResultsReportJob } from 'hooks/useResultsReportJob';
import { useElapsedSeconds, useSecondsSince } from 'hooks/useClock';

interface DashboardProps {
  supplier: any;
  viewType?: string;
}

type PendingRelationshipRemoval = {
  relationshipId: string;
  relatedEntityId: string;
  relatedEntityName?: string;
};

// Constants
// The Activity drawer is full height, so a page fills it rather than leaving
// a short list in a tall box.
const AUDIT_ITEMS_PER_PAGE = 20;

// Matches EntityResultsDownloadModal's sanitizeFileStem, so a report
// downloaded directly from the header icon names its file the same way as
// one downloaded through that modal.
const sanitizeFileStem = (value?: string) => {
  const fallback = 'results_export';
  const baseValue = value?.trim() || fallback;
  const sanitized = baseValue
    .replace(/[^a-zA-Z0-9-_ ]+/g, '')
    .replace(/\s+/g, '_')
    .slice(0, 80);
  return sanitized || fallback;
};

const useDebounce = (value: string, delay: number) => {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => clearTimeout(handler);
  }, [value, delay]);
  return debouncedValue;
};

const Results: React.FC<DashboardProps> = ({
  supplier: initialSupplier,
  viewType,
}) => {
  const { cur_user, userOpts } = useContext(GlobalContext);
  const history = useHistory();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedOptsType, setSelectedOptsType] = useState<string[]>([]);
  const [selectedItems, setSelectedItems] = useState<any[]>([]);
  const [status, setStatus] = useState<string>('');

  const [tab, setTab] = useState<ResultSource>(() => {
    const queryTab = new URLSearchParams(history.location.search)
      .get('tab')
      ?.toLowerCase();
    return queryTab === 'ownership' ? 'ownership' : 'all';
  });
  const [isFrequencyModalOpen, setIsFrequencyModalOpen] = useState(false);

  // Run screening mutation
  const runScreeningMutation = useRunDatabaseScreening();
  const runEntityScreeningMutation = useRunEntityScreening();
  // Beneficial-ownership AI evaluation (on-demand, per selected entity).
  const evaluateOwnershipMutation = useEvaluateOwnership();
  const [ownershipResult, setOwnershipResult] = useState<any>(null);
  const [ownershipPage, setOwnershipPage] = useState(0);
  // The record's section (status tab) is read from ?section= on every render,
  // so a reload, a shared link or a URL change elsewhere all land on it.
  const location = useLocation();
  const section = parseEntityHubSection(
    new URLSearchParams(location.search).get('section'),
  );
  const selectSection = useCallback(
    (next: EntityHubSection) => {
      const searchParams = new URLSearchParams(history.location.search);
      if (next === 'screening') searchParams.delete('section');
      else searchParams.set('section', next);
      const search = searchParams.toString();
      history.replace({
        pathname: history.location.pathname,
        search: search ? `?${search}` : '',
      });
    },
    [history],
  );
  const [helpModalOpen, setHelpModalOpen] = useState(false);
  const [isApprovalModalOpen, setIsApprovalModalOpen] = useState(false);
  const [isHistoryModalOpen, setIsHistoryModalOpen] = useState(false);
  const [isRequestModalOpen, setIsRequestModalOpen] = useState(false);
  const [activeFilter, setActiveFilter] = useState('BITE Lens');
  const [selectedOpts, setSelectedOpts] = useState([]);
  const [curLevel, setCurLevel] = useState(2);
  const [filterOpts, setFilterOpts] = useState<any>({});
  const [screenParmsModal, setScreenParamsModal] = useState(false);
  const [newTab, setNewTab] = useState(false);
  const [curVersion, setCurVersion] = useState<any>(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentItems, setCurrentItems] = useState<any[]>([]);
  const [removeTrigger, setRemoveTrigger] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [openLinkModal, setOpenLinkModal] = useState(false);
  const [isRelationshipModalOpen, setIsRelationshipModalOpen] = useState(false);
  const [trigger, setTrigger] = useState(false);
  const [activePanel, setActivePanel] = useState<
    'comments' | 'screening' | 'audit'
  >('screening');
  const [entityHubDrawer, setEntityHubDrawer] = useState<
    'details' | 'hierarchy' | 'comments' | 'activity' | null
  >(null);
  const [isExportMenuOpen, setIsExportMenuOpen] = useState(false);
  const [matchesCsvJobId, setMatchesCsvJobId] = useState<string | null>(null);
  const [isStartingMatchesCsv, setIsStartingMatchesCsv] = useState(false);
  const handledMatchesCsvJobIdRef = useRef<string | null>(null);
  const [removedDocIds, setRemovedDocIds] = useState<string[]>([]);
  const [bulkSelectedHits, setBulkSelectedHits] = useState<
    Map<string, BulkHitSelection>
  >(() => new Map());
  const [bulkAuditRefreshPending, setBulkAuditRefreshPending] = useState(false);
  const detailsCardRef = useRef<DetailsCardHandles | null>(null);
  const screeningResultsRef = useRef<HTMLDivElement | null>(null);
  const resultsTableRef = useRef<HTMLDivElement | null>(null);
  const shouldScrollToScreeningRef = useRef(false);
  const [isEditingDetails, setIsEditingDetails] = useState(false);
  const [isSavingDetails, setIsSavingDetails] = useState(false);
  const initialEntityId =
    initialSupplier?.entity_id ??
    initialSupplier?.id ??
    initialSupplier?.association_id;
  const [selectedEntityId, setSelectedEntityId] = useState<string | null>(
    initialEntityId ?? null,
  );
  const previousInitialEntityId = useRef<string | null>(null);

  useEffect(() => {
    if (
      initialEntityId &&
      initialEntityId !== previousInitialEntityId.current
    ) {
      setSelectedEntityId(initialEntityId);
      previousInitialEntityId.current = initialEntityId;
    }
  }, [initialEntityId]);

  const activeEntityId = selectedEntityId || initialEntityId;
  const selectedTeamId = cur_user?.selected_team?.id;
  const rootDatabaseId = initialSupplier?.database_id
    ? String(initialSupplier.database_id)
    : '';
  const { data: databaseInfoResponse, isLoading: isDatabaseInfoLoading } =
    useGetDatabaseById(rootDatabaseId, Boolean(rootDatabaseId));
  const { data: selectedEntity } = useGetEntityById(
    activeEntityId ?? undefined,
    Boolean(activeEntityId),
    rootDatabaseId || undefined,
    selectedTeamId ? String(selectedTeamId) : undefined,
  );
  const supplier = selectedEntity || initialSupplier;
  const beneficialOwnershipSettingLoading =
    supplier?.type !== 'products' &&
    isDatabaseInfoLoading &&
    !databaseInfoResponse;
  const beneficialOwnershipEnabled =
    supplier?.type !== 'products' &&
    !beneficialOwnershipSettingLoading &&
    Boolean(databaseInfoResponse) &&
    resolveBeneficialOwnershipEnabled(
      databaseInfoResponse?.screening_lists,
      databaseInfoResponse?.beneficial_ownership_enabled,
    );
  const activeDatabaseEntityId = supplier?.association_id
    ? String(supplier.association_id)
    : supplier?.database_entity_id
    ? String(supplier.database_entity_id)
    : '';

  // The record's Library loads with the record, so the Deep Dive row's count
  // is right before anyone opens it.
  const library = useEntityLibrary(
    supplier?.database_id || initialSupplier?.database_id,
    activeDatabaseEntityId,
  );

  const sourceEntityId =
    activeEntityId ??
    supplier?.entity_id ??
    supplier?.id ??
    supplier?.association_id;
  const matchesCsvJob = useResultsReportJob(matchesCsvJobId);

  const handleDownloadMatchesCsv = useCallback(async () => {
    if (isStartingMatchesCsv || matchesCsvJobId) {
      return;
    }

    const databaseId = supplier?.database_id || initialSupplier?.database_id;
    const groupId = cur_user?.selected_team?.id;

    if (!databaseId) {
      enqueueSnackbar('Database ID is missing. Unable to export matches.', {
        variant: 'error',
      });
      return;
    }
    if (!groupId) {
      enqueueSnackbar('No team selected. Choose a team before exporting.', {
        variant: 'error',
      });
      return;
    }
    if (!sourceEntityId) {
      enqueueSnackbar('Entity ID is missing. Unable to export matches.', {
        variant: 'error',
      });
      return;
    }

    setIsStartingMatchesCsv(true);
    handledMatchesCsvJobIdRef.current = null;
    try {
      const baseName = sanitizeFileStem(
        supplier?.name || initialSupplier?.name,
      );
      const response = await startResultsReport({
        databaseId: String(databaseId),
        groupId: String(groupId),
        options: {
          reportType: 'hits_only',
          includeExecutiveSummary: false,
          includeScreeningResults: true,
          includeBusinessVerification: false,
          includeFullEvidence: true,
          topNResultsPerEntity: 0,
          entityFilters: {
            entityIds: [String(sourceEntityId)],
          },
          output: {
            format: 'csv',
            paperSize: 'LETTER',
            orientation: 'landscape',
          },
          fileName: `${baseName}_screening_results.csv`,
        },
      });

      if (!response.jobId) {
        throw new Error('The CSV export did not return a job ID.');
      }

      setMatchesCsvJobId(response.jobId);
      enqueueSnackbar(
        'Preparing matches CSV. It will download automatically when ready.',
        { variant: 'info' },
      );
    } catch (error: any) {
      enqueueSnackbar(error?.message || 'Failed to export matches CSV.', {
        variant: 'error',
      });
    } finally {
      setIsStartingMatchesCsv(false);
    }
  }, [
    cur_user?.selected_team?.id,
    initialSupplier?.database_id,
    initialSupplier?.name,
    isStartingMatchesCsv,
    matchesCsvJobId,
    sourceEntityId,
    supplier?.database_id,
    supplier?.name,
  ]);

  useEffect(() => {
    if (!matchesCsvJobId) {
      return undefined;
    }
    if (
      matchesCsvJob.status !== 'completed' &&
      matchesCsvJob.status !== 'failed'
    ) {
      return undefined;
    }
    if (handledMatchesCsvJobIdRef.current === matchesCsvJobId) {
      return undefined;
    }

    handledMatchesCsvJobIdRef.current = matchesCsvJobId;

    if (matchesCsvJob.status === 'failed') {
      enqueueSnackbar(
        matchesCsvJob.error || 'Failed to prepare the matches CSV.',
        { variant: 'error' },
      );
      setMatchesCsvJobId(null);
      return undefined;
    }

    let isActive = true;
    const downloadCsv = async () => {
      try {
        const groupId = cur_user?.selected_team?.id;
        if (!groupId) {
          throw new Error('No team selected. Unable to download the CSV.');
        }
        const payload = await getResultsReportDownloadUrl(
          matchesCsvJobId,
          String(groupId),
        );
        if (!payload?.url) {
          throw new Error('The matches CSV download URL is unavailable.');
        }
        if (!isActive) {
          return;
        }

        const downloadLink = document.createElement('a');
        downloadLink.href = payload.url;
        downloadLink.download = payload.fileName || 'matches.csv';
        downloadLink.rel = 'noopener noreferrer';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);

        enqueueSnackbar('Matches CSV downloaded.', { variant: 'success' });
      } catch (error: any) {
        if (isActive) {
          enqueueSnackbar(
            error?.message || 'Failed to download the matches CSV.',
            { variant: 'error' },
          );
        }
      } finally {
        if (isActive) {
          setMatchesCsvJobId(null);
        }
      }
    };

    downloadCsv();
    return () => {
      isActive = false;
    };
  }, [
    cur_user?.selected_team?.id,
    matchesCsvJob.error,
    matchesCsvJob.status,
    matchesCsvJobId,
  ]);

  // Reset the locally-held ownership result when switching entities so a stale
  // run's output never leaks across the panel.
  useEffect(() => {
    setOwnershipResult(null);
    setOwnershipPage(0);
  }, [activeEntityId]);

  // The DatabaseEntity id the ownership endpoint screens (and persists onto).
  const ownershipEntityId =
    supplier?.type === 'products'
      ? undefined
      : supplier?.association_id ??
        supplier?.database_entity_id ??
        activeEntityId ??
        undefined;
  const {
    data: ownershipMatchesResponse,
    isFetching: isOwnershipMatchesLoading,
  } = useGetEntityOwnershipMatches(
    beneficialOwnershipEnabled ? ownershipEntityId : undefined,
    ownershipPage,
    OWNERSHIP_RESULTS_PAGE_SIZE,
  );
  // Prefer this run's fresh result; fall back to the persisted snapshot.
  const ownershipInfo = normalizeOwnershipEvaluation(
    ownershipResult ?? supplier?.ownership_info,
  );
  const hasDetailedOwnershipEvaluation =
    ownershipResult !== null ||
    hasCompletedOwnershipEvaluation(supplier?.ownership_info);

  const handleEvaluateOwnership = async () => {
    if (!beneficialOwnershipEnabled) {
      enqueueSnackbar(
        'Beneficial Ownership is disabled. Enable it in Database Settings to run the 50% Rule Analysis.',
        { variant: 'warning' },
      );
      return;
    }
    if (!supplier?.database_id || !ownershipEntityId) {
      enqueueSnackbar('Cannot evaluate ownership for this entity', {
        variant: 'error',
      });
      return;
    }
    const res = await evaluateOwnershipMutation.mutateAsync({
      databaseId: String(supplier.database_id),
      databaseEntityId: String(ownershipEntityId),
    });
    if (res?.success) {
      const value = normalizeOwnershipEvaluation(res.result);
      if (!value) {
        enqueueSnackbar('Beneficial ownership returned no evaluation', {
          variant: 'warning',
        });
        return;
      }
      setOwnershipResult({ ...value, checked: true });
      enqueueSnackbar('Beneficial ownership evaluation complete', {
        variant: 'success',
      });
    } else {
      enqueueSnackbar('Beneficial ownership evaluation failed', {
        variant: 'error',
      });
    }
  };

  // --- Screening insight cards (AI / Adverse Media / Ownership / Website) ---
  // Adverse media: persisted on the entity, re-runnable on demand.
  const { mutateAsync: runAdverseMedia, isPending: isCheckingAdverseMedia } =
    useRunAndPersistAdverseMedia();
  const [adverseMedia, setAdverseMedia] = useState<any>(null);
  const ownershipCheckElapsed = useElapsedSeconds(
    evaluateOwnershipMutation.isPending,
  );
  const adverseMediaCheckElapsed = useElapsedSeconds(isCheckingAdverseMedia);

  // Adverse media data: this session's run, else the persisted snapshot.
  const adverseMediaData = normalizeAdverseMediaEvaluation(
    adverseMedia ?? supplier?.adverse_media_info,
  );

  // Reset transient insight state when switching entities.
  useEffect(() => {
    setAdverseMedia(null);
  }, [activeEntityId]);

  const handleRunAdverseMedia = async () => {
    if (!supplier?.name) {
      enqueueSnackbar('Cannot run adverse media for this entity', {
        variant: 'error',
      });
      return;
    }
    try {
      const result = await runAdverseMedia({
        entityName: supplier.name,
        country: supplier?.country_of_origin || undefined,
        aliases: Array.isArray(supplier?.aliases) ? supplier.aliases : [],
        databaseEntityId: supplier?.database_entity_id ?? undefined,
        databaseId: supplier?.database_id ?? undefined,
        entityId: supplier?.id ?? undefined,
      });
      const normalizedResult = normalizeAdverseMediaEvaluation(result);
      if (!normalizedResult) {
        enqueueSnackbar('Adverse media check returned no results', {
          variant: 'warning',
        });
        return;
      }
      setAdverseMedia(normalizedResult);
      enqueueSnackbar('Adverse media check complete', {
        variant: 'success',
      });
    } catch {
      enqueueSnackbar('Adverse media check failed', { variant: 'error' });
    }
  };

  // Comment-related state
  const [commentContent, setCommentContent] = useState('');

  // Audit log state
  const [currentAuditPage, setCurrentAuditPage] = useState(1);
  const [auditFilters, setAuditFilters] = useState<IAuditLogDatabaseFilters>(
    EMPTY_AUDIT_LOG_DATABASE_FILTERS,
  );
  const [auditSearchInput, setAuditSearchInput] = useState('');
  const debouncedAuditSearch = useDebounce(auditSearchInput, 500);
  const [showAuditFilterModal, setShowAuditFilterModal] = useState(false);
  // The modal picks calendar days; send them as the bounds of the user's own
  // day so an event at 01:00 local isn't filed under the previous UTC date.
  const auditFiltersWithSearch: IAuditLogDatabaseFilters = {
    ...auditFilters,
    startDate: auditFilters.startDate
      ? moment(auditFilters.startDate, 'YYYY-MM-DD').startOf('day').toISOString()
      : undefined,
    endDate: auditFilters.endDate
      ? moment(auditFilters.endDate, 'YYYY-MM-DD').endOf('day').toISOString()
      : undefined,
    search: debouncedAuditSearch || undefined,
  };
  const hasActiveAuditFilters = hasActiveAuditLogFilters(
    auditFiltersWithSearch,
  );

  // React Query hooks for comments
  const {
    data: comments = [],
    isLoading: isLoadingComments,
    error: commentsError,
    refetch: refetchComments,
  } = useGetCommentsByCommentableId(
    supplier?.association_id,
    supplier?.type === 'supplier' ? 'DatabaseEntity' : 'DatabaseProduct',
  );

  // Comment mutation hooks
  const createCommentMutation = useCreateComment();
  const deleteCommentMutation = useDeleteComment();

  // Status update mutation hooks
  const updateEntityStatusMutation = useUpdateEntityStatus(
    undefined,
    selectedTeamId ? String(selectedTeamId) : undefined,
  );
  const updateProductStatusMutation = useUpdateProductStatus();

  const {
    data: screeningHistoryData,
    isLoading: isScreeningHistoryLoading,
    error: screeningHistoryError,
  } = useGetScreeningHistoryByEntityId(
    supplier?.association_id || supplier?.database_entity_id || supplier?.id,
  );

  const relationshipsEntityId =
    supplier?.type === 'products' ? undefined : sourceEntityId;
  const deleteEntityRelationshipMutation = useDeleteEntityRelationship();
  const [deletingRelationshipId, setDeletingRelationshipId] = useState<
    string | null
  >(null);
  const [pendingRelationshipRemoval, setPendingRelationshipRemoval] =
    useState<PendingRelationshipRemoval | null>(null);
  const { data: entityRelationships = [], isLoading: isLoadingRelationships } =
    useGetEntityRelationships(relationshipsEntityId);
  const rootRelationshipsEntityId =
    initialSupplier?.type === 'products' ? undefined : initialEntityId;
  const { data: rootEntityRelationships = [] } = useGetEntityRelationships(
    rootRelationshipsEntityId,
  );

  const hierarchyEntityId =
    initialSupplier?.type === 'products' ? undefined : initialEntityId;
  const {
    data: entityHierarchyData,
    isLoading: isLoadingHierarchy,
    error: entityHierarchyError,
  } = useGetEntityHierarchy(hierarchyEntityId);

  const formatScreenDate = (isoString?: string | null) => {
    if (!isoString) {
      return '-';
    }
    const parsed = new Date(isoString);
    if (Number.isNaN(parsed.getTime())) {
      return '-';
    }
    // Render the screening instant in UTC (labeled) so it matches the exported
    // PDF report, which also formats screening timestamps in UTC.
    return `${parsed.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      timeZone: 'UTC',
    })} UTC`;
  };

  const formatRelationshipTypeLabel = (value?: string) => {
    if (!value) {
      return '-';
    }
    const acronymLabels: Record<string, string> = {
      ceo: 'CEO',
      cfo: 'CFO',
      coo: 'COO',
      cto: 'CTO',
    };
    return value
      .split('_')
      .map((word) => {
        const normalizedWord = word.toLowerCase();
        return (
          acronymLabels[normalizedWord] ||
          normalizedWord.charAt(0).toUpperCase() + normalizedWord.slice(1)
        );
      })
      .join(' ');
  };
  const parentFromSourceTypes = new Set(['parent_company']);

  const getRelationshipDirection = (relationship: any): 'parent' | 'child' => {
    const relationshipType = relationship?.relationship_type;
    const isSource = relationship?.source_entity_id === sourceEntityId;

    if (relationshipType && parentFromSourceTypes.has(relationshipType)) {
      return isSource ? 'parent' : 'child';
    }

    return isSource ? 'child' : 'parent';
  };

  const toggleEntityDocVisibilityMutation = useToggleEntityDocVisibility();
  const toggleProductDocVisibilityMutation = useToggleProductDocVisibility();
  const bulkHideEntityHitsMutation = useBulkHideEntityHits();
  const bulkUnhideEntityHitsMutation = useBulkUnhideEntityHits();

  useEffect(() => {
    setCurLevel(2);
    setCurrentPage(1);
  }, [activeDatabaseEntityId]);

  useEffect(() => {
    if (!activeDatabaseEntityId) {
      setRemovedDocIds([]);
      return;
    }

    const hiddenIds = Array.isArray(supplier?.hidden_ids)
      ? supplier.hidden_ids.map((id: unknown) => String(id))
      : [];
    const hiddenSet = new Set(hiddenIds);
    setRemovedDocIds(hiddenIds);
    setBulkSelectedHits((previous) => {
      let changed = false;
      const next = new Map(previous);
      previous.forEach((selection, key) => {
        const isNoLongerActionable =
          selection.operation === 'hide'
            ? hiddenSet.has(selection.hitId)
            : !hiddenSet.has(selection.hitId);
        if (
          selection.databaseEntityId === activeDatabaseEntityId &&
          isNoLongerActionable
        ) {
          next.delete(key);
          changed = true;
        }
      });
      return changed ? next : previous;
    });
  }, [activeDatabaseEntityId, supplier?.hidden_ids]);

  const isProductRecord = supplier?.type === 'products';
  const auditEntityRef = isProductRecord ? null : entityRef(supplier);
  const auditProductId = isProductRecord ? supplier?.id : null;
  const auditOffset = (currentAuditPage - 1) * AUDIT_ITEMS_PER_PAGE;

  const entityActivitySummary = useEntityTimeline(
    auditEntityRef,
    supplier?.database_id ? String(supplier.database_id) : undefined,
    selectedTeamId ? String(selectedTeamId) : undefined,
    !isProductRecord,
    1,
    0,
  );

  const entityTimeline = useEntityTimeline(
    auditEntityRef,
    supplier?.database_id ? String(supplier.database_id) : undefined,
    selectedTeamId ? String(selectedTeamId) : undefined,
    activePanel === 'audit' && !isProductRecord,
    AUDIT_ITEMS_PER_PAGE,
    auditOffset,
    auditFiltersWithSearch,
  );

  const {
    data: auditFilterActions = [],
    isError: auditFilterActionsFailed,
  } = useGetAuditLogActionsByEntityAssociation(
    auditEntityRef,
    supplier?.database_id ? String(supplier.database_id) : undefined,
    selectedTeamId ? String(selectedTeamId) : undefined,
  );

  const {
    data: auditFilterPeople = [],
    isError: auditFilterPeopleFailed,
  } = useGetAuditLogActorsByEntityAssociation(
    auditEntityRef,
    supplier?.database_id ? String(supplier.database_id) : undefined,
    selectedTeamId ? String(selectedTeamId) : undefined,
  );

  const clearAuditFilters = () => {
    setAuditFilters(EMPTY_AUDIT_LOG_DATABASE_FILTERS);
    setAuditSearchInput('');
  };

  const auditFilterChips: AuditFilterChip[] = [];
  if (auditFilters.startDate || auditFilters.endDate) {
    const formatDay = (day: string) =>
      moment(day, 'YYYY-MM-DD').format('MMM D, YYYY');
    auditFilterChips.push({
      key: 'dates',
      label:
        auditFilters.startDate && auditFilters.endDate
          ? `${formatDay(auditFilters.startDate)} – ${formatDay(
              auditFilters.endDate,
            )}`
          : auditFilters.startDate
          ? `From ${formatDay(auditFilters.startDate)}`
          : `Until ${formatDay(auditFilters.endDate || '')}`,
      onRemove: () =>
        setAuditFilters((prev) => ({
          ...prev,
          startDate: undefined,
          endDate: undefined,
        })),
    });
  }
  (auditFilters.actions || []).forEach((action) => {
    auditFilterChips.push({
      key: `action:${action}`,
      label: formatAuditActionLabel(action),
      onRemove: () =>
        setAuditFilters((prev) => ({
          ...prev,
          actions: (prev.actions || []).filter((item) => item !== action),
        })),
    });
  });
  (auditFilters.userIds || []).forEach((userId) => {
    const actor = auditFilterPeople.find(
      (person) => auditActorId(person) === userId,
    );
    auditFilterChips.push({
      key: `user:${userId}`,
      label: actor ? auditActorLabel(actor) : 'Unknown user',
      onRemove: () =>
        setAuditFilters((prev) => ({
          ...prev,
          userIds: (prev.userIds || []).filter((item) => item !== userId),
        })),
    });
  });

  // Any Audit Log filter/search change invalidates the current offset --
  // jump back to page 1 rather than risk landing past the end of a now-
  // shorter set.
  useEffect(() => {
    setCurrentAuditPage(1);
  }, [auditFilters, debouncedAuditSearch]);

  const {
    data: productAuditLogsData,
    isLoading: isLoadingProductAuditLogs,
    error: productAuditLogsError,
    refetch: refetchProductAuditLogs,
  } = useGetAuditLogsByProductIdPaginated(
    auditProductId || '',
    AUDIT_ITEMS_PER_PAGE,
    auditOffset,
  );

  const {
    data: databaseAuditLogsData,
    isLoading: isLoadingDatabaseAuditLogs,
    error: databaseAuditLogsError,
    refetch: refetchDatabaseAuditLogs,
  } = useGetAuditLogsByDatabaseIdPaginated(
    isProductRecord ? supplier?.database_id || '' : '',
    AUDIT_ITEMS_PER_PAGE,
    auditOffset,
    true, // includeErrors: show failure audit logs alongside normal activity
  );

  const [shareModalOpen, setShareShowModalOpen] = useState<boolean>(false);
  const [isChangeStatusModalOpen, setIsChangeStatusModalOpen] =
    useState<boolean>(false);
  const [isChangingStatus, setIsChangingStatus] = useState<boolean>(false);
  const [currentStatusFlag, setCurrentStatusFlag] = useState<string>(
    supplier?.status_flag || 'new',
  );

  const productPrimaryTotalItems =
    productAuditLogsData?.pagination?.totalItems || 0;
  const productUsesDatabaseFallback =
    !isLoadingProductAuditLogs && productPrimaryTotalItems === 0;
  const productAuditPage = productUsesDatabaseFallback
    ? databaseAuditLogsData
    : productAuditLogsData;
  const isLoadingProductAudit =
    isLoadingProductAuditLogs ||
    (productUsesDatabaseFallback && isLoadingDatabaseAuditLogs);
  const productAuditError = productUsesDatabaseFallback
    ? productAuditLogsError || databaseAuditLogsError
    : productAuditLogsError;

  const productTimeline: ScopedQuery<IAuditLogPageResponse> = !isProductRecord
    ? { status: 'idle' }
    : productAuditError
    ? {
        status: 'error',
        error:
          productAuditError instanceof Error
            ? productAuditError
            : new Error(String(productAuditError)),
        retry: () => {
          refetchProductAuditLogs();
          refetchDatabaseAuditLogs();
        },
      }
    : isLoadingProductAudit || !productAuditPage
    ? { status: 'loading' }
    : { status: 'ready', data: productAuditPage };

  const auditTimeline = isProductRecord ? productTimeline : entityTimeline;
  const auditPage =
    auditTimeline.status === 'ready' ? auditTimeline.data : undefined;
  const currentAuditLogsData = auditPage?.data || [];
  const entityActivityCount =
    entityActivitySummary.status === 'ready'
      ? entityActivitySummary.data.pagination.totalItems
      : entityActivitySummary.status === 'empty'
      ? 0
      : null;

  useEffect(() => {
    if (auditTimeline.status === 'error') {
      console.error('Audit timeline failed:', auditTimeline.error);
    }
  }, [auditTimeline]);

  const queryClient = useQueryClient();

  useEffect(() => {
    if (activePanel !== 'audit' || !bulkAuditRefreshPending) {
      return;
    }

    queryClient.invalidateQueries({ queryKey: ['audit'] });
    const retryTimers = [1000, 3000].map((delay, index) =>
      window.setTimeout(() => {
        queryClient.invalidateQueries({ queryKey: ['audit'] });
        if (index === 1) {
          setBulkAuditRefreshPending(false);
        }
      }, delay),
    );

    return () => retryTimers.forEach((timer) => window.clearTimeout(timer));
  }, [activePanel, bulkAuditRefreshPending, queryClient]);
  // Entity records poll the entity service for live screening progress; product
  // records poll the product service.
  const { data: screeningStatus, refetch: refetchScreeningStatus } =
    useGetDatabaseScreeningStatus(
      supplier?.database_id,
      supplier?.type === 'supplier',
    );

  // The team-level entitlement (cur_user.hasEntityAddon) decides whether the
  // verification panel offers runs or points the Team to sales. The per-database
  // `entity_add_on_enabled` toggle governs whether it's actively running — when
  // false, the panel still renders but its run buttons are disabled with an
  // explanation.

  // Entity screening runs in stages (OpenSearch, then AI + verification). The
  // response can still report verificationInProgress after inProgress/aiInProgress
  // clear, so include it here — otherwise the detail view declares the run complete
  // early, refreshes before verification data lands, and re-enables Run Screen while
  // verification is still active. Matches the action-lock in DatabaseInfo.tsx.
  const isScreeningCurrently =
    screeningStatus?.inProgress ||
    screeningStatus?.aiInProgress ||
    screeningStatus?.verificationInProgress ||
    false;
  const isEntityRecord = supplier?.type === 'supplier';
  const isOpensearchInProgress = screeningStatus?.inProgress === true;
  const isScreeningDelayed =
    isEntityRecord &&
    screeningStatus?.health === 'delayed' &&
    isScreeningCurrently;
  const screeningProcessed = screeningStatus?.run?.entitiesProcessed;
  const screeningTotal = screeningStatus?.run?.entitiesTotal;
  const screeningCountLabel =
    isOpensearchInProgress &&
    typeof screeningTotal === 'number' &&
    screeningTotal > 0
      ? `${Number(screeningProcessed) || 0} of ${screeningTotal}`
      : null;
  const screeningProgress = screeningStatus?.progress || null;

  const relatedEntities = useMemo(() => {
    if (!sourceEntityId || !Array.isArray(entityRelationships)) {
      return [];
    }
    const map = new Map<string, { id: string; name: string; type: string }>();
    entityRelationships.forEach((relationship: any) => {
      const isSource = relationship.source_entity_id === sourceEntityId;
      const relatedId = isSource
        ? relationship.target_entity_id
        : relationship.source_entity_id;
      const relatedName = isSource
        ? relationship.target_entity_name
        : relationship.source_entity_name;
      if (!relatedId || !relatedName) {
        return;
      }
      if (!map.has(relatedId)) {
        map.set(relatedId, {
          id: relatedId,
          name: relatedName,
          type: relationship.relationship_type,
        });
      }
    });
    return Array.from(map.values());
  }, [entityRelationships, sourceEntityId]);

  const linkedEntityGroups = useMemo(() => {
    const counts: Record<'parent' | 'child', number> = {
      parent: 0,
      child: 0,
    };

    entityRelationships.forEach((relationship: any) => {
      const direction = getRelationshipDirection(relationship);
      counts[direction] += 1;
    });

    return (['parent', 'child'] as const)
      .filter((type) => counts[type] > 0)
      .map((type) => ({
        type: type,
        count: counts[type],
      }));
  }, [entityRelationships, sourceEntityId]);

  // Track screening status to detect completion
  const prevInProgressRef = useRef(false);

  useEffect(() => {
    if (prevInProgressRef.current && !isScreeningCurrently) {
      // Screening just finished! Invalidate queries to refresh data
      const id =
        supplier?.association_id ||
        supplier?.database_entity_id ||
        supplier?.id;

      if (id) {
        queryClient.invalidateQueries({
          queryKey: screeningKeys.entityHistoryById(String(id)),
        });
      }
      if (activeEntityId) {
        queryClient.invalidateQueries({
          queryKey: ['entity', 'by-id', String(activeEntityId)],
        });
      }
      if (ownershipEntityId) {
        setOwnershipPage(0);
        queryClient.invalidateQueries({
          queryKey: entityKeys.ownershipMatches(String(ownershipEntityId)),
        });
      }
      queryClient.invalidateQueries({
        queryKey: ['audit'],
      });
      queryClient.invalidateQueries({
        queryKey: databaseKeys.databases(),
        exact: false,
      });
      // Also refresh the supplier itself if needed, or other related data
    }
    prevInProgressRef.current = isScreeningCurrently;
  }, [
    activeEntityId,
    ownershipEntityId,
    isScreeningCurrently,
    queryClient,
    supplier,
  ]);

  // Detect when saving finishes to check for new screening status
  const prevIsSavingRef = useRef(false);
  useEffect(() => {
    if (prevIsSavingRef.current && !isSavingDetails) {
      // Just finished saving details, check for screening status
      refetchScreeningStatus();
    }
    prevIsSavingRef.current = isSavingDetails;
  }, [isSavingDetails, refetchScreeningStatus]);

  type CreateCommentInput = {
    commentable_type: 'DatabaseEntity' | 'DatabaseProduct';
    commentable_id: string;
    content: string;
    author_id?: string;
    author_name?: string;
    parent_comment_id?: string | null;
  };

  // Sync local status with supplier prop changes
  useEffect(() => {
    setCurrentStatusFlag(supplier?.status_flag || 'new');
  }, [supplier?.status_flag]);

  useEffect(() => {
    setIsEditingDetails(false);
    setIsSavingDetails(false);
  }, [supplier?.id]);

  useEffect(() => {
    if (
      activePanel === 'screening' &&
      shouldScrollToScreeningRef.current &&
      screeningResultsRef.current
    ) {
      screeningResultsRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
      shouldScrollToScreeningRef.current = false;
    }
  }, [activePanel]);

  const decompressData = (compressedData: any) => {
    if (compressedData === undefined || compressedData.length === 0) {
      return {};
    }
    const compressedBuffer = Buffer.from(compressedData, 'base64');
    const decompressed = pako.ungzip(compressedBuffer, { to: 'string' });
    return JSON.parse(decompressed);
  };

  useEffect(() => {
    if (supplier && Array.isArray(supplier.hidden_ids)) {
      const hiddenIds = supplier.hidden_ids.map((id: any) => String(id));
      setRemovedDocIds(hiddenIds);
    } else {
      setRemovedDocIds([]);
    }
  }, [supplier]);

  // Handle comment loading errors
  useEffect(() => {
    if (commentsError) {
      enqueueSnackbar('Failed to load comments', { variant: 'error' });
    }
  }, [commentsError]);

  const handleAddComment = async () => {
    if (!commentContent.trim() || !supplier?.id || !cur_user) {
      return;
    }

    try {
      const commentData: CreateCommentInput = {
        commentable_type:
          supplier.type === 'supplier' ? 'DatabaseEntity' : 'DatabaseProduct',
        commentable_id: String(
          supplier.association_id ?? supplier.association_product_id ?? '',
        ),
        content: commentContent.trim(),
        author_id: cur_user.basics?.id ?? undefined,
        author_name:
          (cur_user.basics?.firstName && cur_user.basics?.lastName
            ? `${cur_user.basics.firstName} ${cur_user.basics.lastName}`
            : cur_user.basics?.email) || 'Anonymous',
      };

      const result = await createCommentMutation.mutateAsync(commentData);

      if (result) {
        setCommentContent('');
        enqueueSnackbar('Comment added successfully', { variant: 'success' });
        // React Query should refetch via your hook's onSuccess
      }
    } catch (error) {
      console.error('Error adding comment:', error);
      enqueueSnackbar('Error adding comment', { variant: 'error' });
    }
  };

  const handleDeleteComment = async (commentId?: string) => {
    if (!commentId) {
      enqueueSnackbar('Unable to delete comment. Please try again later', {
        variant: 'error',
      });
      return;
    }
    try {
      const result = await deleteCommentMutation.mutateAsync(commentId);
      if (result) {
        enqueueSnackbar('Comment deleted successfully', { variant: 'success' });
      }
    } catch (error) {
      console.error('Error deleting comment:', error);
      enqueueSnackbar('Error deleting comment', { variant: 'error' });
    }
  };

  const handleStatusUpdate = async (status: string) => {
    try {
      setIsChangingStatus(true);

      if (supplier?.type === 'products') {
        if (!supplier?.id) {
          enqueueSnackbar('Product ID is missing', { variant: 'error' });
          setIsChangingStatus(false);
          return;
        }

        const productData = { status_flag: status };
        const result = await updateProductStatusMutation.mutateAsync({
          id: supplier.id,
          statusData: productData,
        });

        if (result) {
          enqueueSnackbar('Product status updated successfully', {
            variant: 'success',
          });
          setIsChangeStatusModalOpen(false);
          setCurrentStatusFlag(status);
          setTrigger(!trigger);
        }
      } else {
        if (!supplier?.association_id) {
          enqueueSnackbar('Entity ID is missing', { variant: 'error' });
          setIsChangingStatus(false);
          return;
        }
        const entityData = { status_flag: status };
        const result = await updateEntityStatusMutation.mutateAsync({
          id: supplier.association_id,
          statusData: entityData,
        });

        if (result) {
          enqueueSnackbar('Entity status updated successfully', {
            variant: 'success',
          });
          setIsChangeStatusModalOpen(false);
          setCurrentStatusFlag(status);
          setTrigger(!trigger);
        }
      }
    } catch (error) {
      console.error('Error updating status:', error);
      enqueueSnackbar('Error updating status', { variant: 'error' });
    } finally {
      setIsChangingStatus(false);
    }
  };

  // Process screening history data when it changes - using new endpoint structure
  useEffect(() => {
    if (screeningHistoryData?.latestResult) {
      const latestResult = screeningHistoryData.latestResult;

      // Get all_results from the latest screening result
      if (latestResult.all_results) {
        try {
          // all_results is a string that may be compressed or JSON
          let parsedData;

          // Try to decompress if it's base64 compressed data
          try {
            const decompData = decompressData(latestResult.all_results);
            parsedData =
              typeof decompData === 'string'
                ? JSON.parse(decompData)
                : decompData;
          } catch (decompError) {
            // If decompression fails, try parsing as regular JSON
            parsedData = JSON.parse(latestResult.all_results);
          }

          // Handle the case where parsedData might not be an array
          const dataArray = Array.isArray(parsedData)
            ? parsedData
            : [parsedData];

          // Structure the data as expected by the screening results table
          const processedData = [
            {
              field: supplier?.name,
              docs: markAndMoveRemoved(dataArray),
              hits: latestResult.hit_count || dataArray.length,
              new_total: latestResult.new_total,
              diff_added_count: latestResult.diff_added_count,
              diff_removed_count: latestResult.diff_removed_count,
              diff_modified_count: latestResult.diff_modified_count,
              is_base_snapshot: latestResult.is_base_snapshot,
              ai_summary: latestResult.ai_summary,
              doc_info: latestResult.doc_info,
              screening_timestamp: latestResult.screening_timestamp,
            },
          ];

          setPassedDownResults(processedData);
        } catch (error) {
          console.error('Error parsing screening results:', error);
          enqueueSnackbar('Error parsing screening results', {
            variant: 'error',
          });
          setPassedDownResults([]);
        }
      } else {
        setPassedDownResults([]);
      }
    } else {
      setPassedDownResults([]);
    }
  }, [screeningHistoryData, removedDocIds, supplier?.name]);

  // Handle screening history loading errors
  useEffect(() => {
    if (screeningHistoryError) {
      enqueueSnackbar('Failed to fetch screening history', {
        variant: 'error',
      });
    }
  }, [screeningHistoryError]);

  // Handle audit logs loading errors
  useEffect(() => {
    if (auditTimeline.status === 'error') {
      enqueueSnackbar('Failed to fetch audit logs', {
        variant: 'error',
      });
    }
  }, [auditTimeline.status]);

  // Update loading state based on React Query loading state
  useEffect(() => {
    if (isScreeningHistoryLoading !== isLoading) {
      setIsLoading(isScreeningHistoryLoading);
    }
  }, [isScreeningHistoryLoading]);

  const [passedDownResults, setPassedDownResults] = useState<any[]>([]);
  const screeningResultsTotal = Number(supplier?.hit_count ?? 0);

  const aiSums = useMemo(() => {
    const ai = screeningHistoryData?.latestResult?.ai_summary;
    if (!ai) {
      return [
        {
          entity_name: supplier?.name || '-',
          risk: '-',
          best_match: '-',
          match_probability: 0,
          explanation: '-',
          screenDate: '-',
          document_count: 0,
          top_matches: [],
        },
      ];
    }
    // Prefer normalized `top_matches`, else adapt from `best_matches`
    const legacyBestMatches = Array.isArray((ai as any)?.best_matches)
      ? (ai as any).best_matches
      : null;

    const topMatchesArray = Array.isArray(ai.top_matches)
      ? ai.top_matches
      : legacyBestMatches
      ? legacyBestMatches.map((m: any) => ({
          id: m.id ?? null,
          name: m.name,
          confidence: m.confidence,
        }))
      : [];

    const top0 = topMatchesArray[0];
    const best_match = ai.best_match ?? (top0?.name || '-');

    const match_probability =
      typeof ai.match_probability === 'number'
        ? ai.match_probability
        : typeof top0?.confidence === 'number'
        ? top0.confidence
        : 0;

    return [
      {
        entity_name: ai.entity_name || supplier?.name || '-',
        risk: ai.risk ?? '-',
        best_match: best_match,
        match_probability: match_probability,
        explanation: ai.explanation ?? '-',
        document_count: (ai as any)?.document_count ?? 0,
        screenDate: formatScreenDate(
          screeningHistoryData?.latestResult?.created_at,
        ),
        // osint is on-demand (Adverse Media card), so it's fine if this is missing
        osint: undefined,
        top_matches: topMatchesArray,
      },
    ];
  }, [supplier, screeningHistoryData]);

  // AI-evaluation derivations for the screening insight cards (defined here,
  // after `aiSums`). `risk: '-'` / `explanation: '-'` are the no-data sentinels.
  /**
   * Assembles the canonical Entity Screening report payload for THIS entity, in
   * the same shape the Entity Screening tool passes to `screeningTicketEntityPDF`
   * when a saved-work ticket is saved. Handed to the download modal so a
   * single-entity export produces a byte-for-byte equivalent report; the
   * whole-database export is untouched and keeps its server-generated outputs.
   *
   * Returns null only while results are still being fetched, so the modal can
   * say so. A loaded-but-empty screen still produces a report.
   */
  const buildEntityScreeningReport =
    useCallback((): IEntityTicketReportData | null => {
      const entityDocs = (passedDownResults || []).flatMap((group: any) =>
        Array.isArray(group?.docs) ? group.docs : [],
      );
      const ownershipDocs = Array.isArray(
        ownershipMatchesResponse?.result?.results,
      )
        ? ownershipMatchesResponse.result.results
        : Array.isArray(ownershipInfo?.matches)
        ? ownershipInfo.matches
        : [];

      // Gate on the actual fetch, NOT on empty arrays. A completed screen with
      // zero matches is a valid report -- returning null there made the modal
      // read it as "still loading" and blocked clean entities from exporting.
      if (isOwnershipMatchesLoading) {
        return null;
      }

      const preparedBy =
        (cur_user?.basics?.firstName && cur_user?.basics?.lastName
          ? `${cur_user.basics.firstName} ${cur_user.basics.lastName}`
          : cur_user?.basics?.email) || '';

      return {
        ticketName: supplier?.name || 'Entity',
        entity: {
          primary: supplier?.name || '',
          country: supplier?.country_of_origin || '',
          address: supplier?.address || '',
        },
        aiSums: aiSums,
        beneficialOwnership: ownershipInfo ?? null,
        adverseMedia: adverseMediaData,
        entityDocs: entityDocs,
        ownershipDocs: ownershipDocs,
        entityTotal: screeningResultsTotal,
        ownershipTotal: ownershipDocs.length,
        preparedBy: preparedBy,
      };
    }, [
      adverseMediaData,
      aiSums,
      cur_user,
      ownershipInfo,
      ownershipMatchesResponse,
      isOwnershipMatchesLoading,
      passedDownResults,
      screeningResultsTotal,
      supplier,
    ]);

  const [isDownloadingEntityReport, setIsDownloadingEntityReport] =
    useState(false);

  // Directly generates and downloads the entity's PDF screening report --
  // the same client-side PDFKit render EntityResultsDownloadModal's
  // "Entity screening report (PDF)" option uses -- without showing that
  // modal's CSV/PDF choice at all.
  const handleDownloadEntityReport = useCallback(async () => {
    if (isDownloadingEntityReport) {
      return;
    }
    const reportData = buildEntityScreeningReport();
    if (!reportData) {
      enqueueSnackbar(
        'Screening results for this entity are still loading. Try again in a moment.',
        { variant: 'warning' },
      );
      return;
    }

    setIsDownloadingEntityReport(true);
    try {
      const baseName = sanitizeFileStem(
        supplier?.name || initialSupplier?.name,
      );
      await screeningTicketEntityPDF(
        reportData,
        `${baseName}_entity_screening_report.pdf`,
      );
      enqueueSnackbar('Entity screening report downloaded.', {
        variant: 'success',
      });
    } catch (error: any) {
      enqueueSnackbar(
        error?.message || 'Failed to generate the entity screening report.',
        { variant: 'error' },
      );
    } finally {
      setIsDownloadingEntityReport(false);
    }
  }, [
    buildEntityScreeningReport,
    initialSupplier?.name,
    isDownloadingEntityReport,
    supplier?.name,
  ]);

  const aiSummary = aiSums?.[0] ?? null;
  const aiHasEvaluation = Boolean(
    aiSummary && aiSummary.risk !== '-' && aiSummary.explanation !== '-',
  );
  const aiRiskLabel: string = aiHasEvaluation
    ? aiSummary?.risk_level || aiSummary?.risk || supplier?.risk_level || 'N/A'
    : supplier?.risk_level || 'N/A';
  const aiExplanation: string =
    aiHasEvaluation && aiSummary?.explanation !== '-'
      ? aiSummary?.explanation || ''
      : '';
  const aiTopMatches: string[] = Array.isArray(aiSummary?.top_matches)
    ? aiSummary.top_matches
        .map((m: any) => (typeof m === 'string' ? m : m?.name))
        .filter(Boolean)
    : [];

  const handleSelectAll = () => {
    if (curLevel === 2) {
      setSelectedItems((prevSelected: any[]) => {
        const safePrevSelected = Array.isArray(prevSelected)
          ? prevSelected
          : [];

        const existingNames = safePrevSelected.map((item) => item.name);
        const newItems = currentItems
          .filter((item) => !existingNames.includes(item.key))
          .map((item) => ({
            name: item.key,
            results: item.items,
          }));

        return [...safePrevSelected, ...newItems];
      });
    }
  };

  const handleClearAll = () => {
    setSelectedItems([]);
  };

  const handleDetailsCancel = () => {
    detailsCardRef.current?.cancel();
  };

  const handleDetailsSave = () => {
    detailsCardRef.current?.save();
  };

  const handleOpenOwnershipSettings = useCallback(() => {
    if (!rootDatabaseId) {
      return;
    }
    const settingsParams = new URLSearchParams({
      tab: 'Screening Settings',
    });
    history.push({
      pathname: `/database/${rootDatabaseId}`,
      search: `?${settingsParams.toString()}`,
    });
  }, [history, rootDatabaseId]);

  const handleToggleEntityDocVisibility = async (
    entityId: string,
    docId: string,
  ) => {
    try {
      const result = await toggleEntityDocVisibilityMutation.mutateAsync({
        parentId: entityId,
        itemId: docId,
      });
      if (result?.success) {
        enqueueSnackbar('Entity document visibility toggled successfully', {
          variant: 'success',
        });
        setTrigger(!trigger);
      } else {
        enqueueSnackbar('Error toggling entity document visibility', {
          variant: 'error',
        });
      }
    } catch (error) {
      console.error('Error toggling entity document visibility:', error);
      enqueueSnackbar('Error toggling entity document visibility', {
        variant: 'error',
      });
    }
  };

  const handleToggleProductDocVisibility = async (
    productId: string,
    docId: string,
  ) => {
    try {
      const result = await toggleProductDocVisibilityMutation.mutateAsync({
        parentId: productId,
        itemId: docId,
      });
      if (result?.success) {
        enqueueSnackbar('Product document visibility toggled successfully', {
          variant: 'success',
        });
        setTrigger(!trigger);
      } else {
        enqueueSnackbar('Error toggling product document visibility', {
          variant: 'error',
        });
      }
    } catch (error) {
      console.error('Error toggling product document visibility:', error);
      enqueueSnackbar('Error toggling product document visibility', {
        variant: 'error',
      });
    }
  };

  const removeHit = async (
    id: string,
    reason?: string,
    recordName?: string,
  ) => {
    try {
      let result;
      if (supplier && supplier.type === 'supplier') {
        result = await toggleEntityDocVisibilityMutation.mutateAsync({
          parentId: supplier.association_id,
          itemId: id,
          reason: reason,
          itemName: recordName,
        });
      } else if (supplier && supplier.type === 'products') {
        result = await toggleProductDocVisibilityMutation.mutateAsync({
          parentId: supplier.association_id,
          itemId: id,
          reason: reason,
          itemName: recordName,
        });
      }

      if (result?.success) {
        setRemovedDocIds((prev) => {
          const docId = id;
          const isCurrentlyRemoved = prev.includes(docId);

          if (isCurrentlyRemoved) {
            return prev.filter((removedId) => removedId !== docId);
          }
          return [...prev, docId];
        });

        if (activeDatabaseEntityId) {
          const selectionKey = getBulkHitSelectionKey(
            activeDatabaseEntityId,
            id,
          );
          setBulkSelectedHits((previous) => {
            if (!previous.has(selectionKey)) {
              return previous;
            }
            const next = new Map(previous);
            next.delete(selectionKey);
            return next;
          });
        }

        enqueueSnackbar('Document visibility toggled', {
          variant: 'success',
        });

        // React Query will automatically invalidate and refetch the screening history
        // due to the onSuccess callback in the mutation hooks
      } else {
        enqueueSnackbar('Error toggling document visibility', {
          variant: 'error',
        });
      }
    } catch (error) {
      console.error('Error in removeHit:', error);
      enqueueSnackbar('Error toggling document visibility', {
        variant: 'error',
      });
    }
  };

  const handleBulkUpdateHits = async (
    operation: BulkHitVisibilityOperation,
    comment: string,
  ) => {
    const selections = Array.from(bulkSelectedHits.values()).filter(
      (selection) => selection.operation === operation,
    );
    if (selections.length === 0) {
      return;
    }
    if (!selectedTeamId) {
      enqueueSnackbar(
        `Select a team before ${
          operation === 'hide' ? 'hiding' : 'unhiding'
        } hits`,
        {
          variant: 'error',
        },
      );
      throw new Error('A selected team is required');
    }

    const grouped = new Map<string, string[]>();
    selections.forEach((selection) => {
      const hitIds = grouped.get(selection.databaseEntityId) ?? [];
      hitIds.push(selection.hitId);
      grouped.set(selection.databaseEntityId, hitIds);
    });

    try {
      const payload = {
        entities: Array.from(grouped.entries()).map(
          ([databaseEntityId, hitIds]) => ({
            database_entity_id: databaseEntityId,
            hit_ids: hitIds,
          }),
        ),
        ...(comment ? { comment: comment } : {}),
      };
      let changedHits = 0;
      let affectedEntityCount = 0;

      if (operation === 'hide') {
        const result = await bulkHideEntityHitsMutation.mutateAsync({
          payload: payload,
          selectedTeamId: String(selectedTeamId),
        });
        changedHits = result.hidden_hits;
        affectedEntityCount = result.entities.length;
        const activeEntity = result.entities.find(
          (entity) => entity.database_entity_id === activeDatabaseEntityId,
        );
        if (activeEntity) {
          const completedIds = [
            ...activeEntity.hidden_hit_ids,
            ...activeEntity.already_hidden_hit_ids,
          ];
          setRemovedDocIds((previous) =>
            Array.from(new Set([...previous, ...completedIds])),
          );
        }
      } else {
        const result = await bulkUnhideEntityHitsMutation.mutateAsync({
          payload: payload,
          selectedTeamId: String(selectedTeamId),
        });
        changedHits = result.unhidden_hits;
        affectedEntityCount = result.entities.length;
        const activeEntity = result.entities.find(
          (entity) => entity.database_entity_id === activeDatabaseEntityId,
        );
        if (activeEntity) {
          const completedIds = new Set([
            ...activeEntity.unhidden_hit_ids,
            ...activeEntity.already_visible_hit_ids,
          ]);
          setRemovedDocIds((previous) =>
            previous.filter((hitId) => !completedIds.has(hitId)),
          );
        }
      }

      setBulkSelectedHits(new Map());
      if (changedHits > 0) {
        setBulkAuditRefreshPending(true);
      }
      enqueueSnackbar(
        changedHits > 0
          ? `${changedHits} hit${changedHits === 1 ? '' : 's'} ${
              operation === 'hide' ? 'hidden' : 'unhidden'
            } across ${affectedEntityCount} entit${
              affectedEntityCount === 1 ? 'y' : 'ies'
            }`
          : `The selected hits were already ${
              operation === 'hide' ? 'hidden' : 'visible'
            }`,
        { variant: 'success' },
      );
    } catch (error: any) {
      enqueueSnackbar(
        error?.response?.data?.message ||
          error?.message ||
          `Failed to ${operation} selected hits`,
        { variant: 'error' },
      );
      throw error;
    }
  };

  /**
   * Mark removed items and move them to the bottom of the array
   * @param {any[]} arr - Array of items to process
   * @returns {any[]} Array with removed items marked and moved to bottom
   */
  const markAndMoveRemoved = (arr: any[]) => {
    const remaining: any[] = [];
    const removed: any[] = [];

    for (const item of arr) {
      const docId = item['BITE Record ID'] || item.id;
      if (removedDocIds.includes(docId)) {
        removed.push({ ...item, removed: true });
      } else {
        remaining.push(item);
      }
    }

    return [...remaining, ...removed];
  };

  // Extract screening date from React Query screening history data
  const screeningDate = useMemo(() => {
    // Get from new endpoint structure
    if (screeningHistoryData?.latestResult) {
      const latestResult = screeningHistoryData.latestResult;
      return (
        latestResult.last_screening_date ||
        latestResult.screening_timestamp ||
        latestResult.created_at
      );
    }

    // Fallback to supplier data if React Query data not available
    if (supplier?.screening && supplier.screening.length > 0) {
      const latestScreening = supplier.screening[0];
      return latestScreening.created_at || latestScreening.screening_timestamp;
    }

    return null;
  }, [screeningHistoryData, supplier]);

  const mockCase = {
    data: {
      removedHits: removedDocIds,
      screeningDate: screeningDate,
    },
  };

  // Transform audit log data to match AuditLogRow expected format
  const auditActivities = useMemo(() => {
    if (!currentAuditLogsData || !Array.isArray(currentAuditLogsData)) {
      return [];
    }

    const preferredEntityId = auditEntityRef
      ? String(auditEntityRef.entityId)
      : null;
    const preferredProductId = auditProductId ? String(auditProductId) : null;
    const isProductContext = isProductRecord;

    return currentAuditLogsData.map((auditLog) => {
      const affectedItems = auditLog.affected_items || [];

      let itemMessage: string | undefined = undefined;
      let matchingItem = undefined;
      if (isProductContext && preferredProductId) {
        matchingItem = affectedItems.find(
          (item) =>
            item?.product_id && String(item.product_id) === preferredProductId,
        );
      } else if (!isProductContext && preferredEntityId) {
        matchingItem = affectedItems.find(
          (item) =>
            item?.entity_id && String(item.entity_id) === preferredEntityId,
        );
      }
      itemMessage = matchingItem?.message ?? undefined;

      const resolvedMessage =
        itemMessage || auditLog.message || 'No action specified';

      return {
        user: {
          firstName: auditLog.user_name?.split(' ')[0] || 'Unknown',
          lastName: auditLog.user_name?.split(' ').slice(1).join(' ') || 'User',
        },
        action: resolvedMessage,
        timeStamp: auditLog.updated_at || new Date().toISOString(),
      };
    });
  }, [currentAuditLogsData, auditEntityRef, auditProductId, isProductRecord]);

  const hasAuditPagination = Boolean(auditPage?.pagination);
  const totalAuditPages = Math.max(
    1,
    auditPage?.pagination?.totalPages ??
      (currentAuditLogsData.length >= AUDIT_ITEMS_PER_PAGE
        ? currentAuditPage + 1
        : currentAuditPage),
  );

  useEffect(() => {
    if (
      auditTimeline.status !== 'loading' &&
      hasAuditPagination &&
      currentAuditPage > totalAuditPages
    ) {
      setCurrentAuditPage(totalAuditPages);
    }
  }, [
    auditTimeline.status,
    currentAuditPage,
    hasAuditPagination,
    totalAuditPages,
  ]);

  const handleNextAuditPage = () => {
    setCurrentAuditPage((prevPage) => Math.min(prevPage + 1, totalAuditPages));
  };

  const handlePrevAuditPage = () => {
    setCurrentAuditPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  const auditPanelState: ScopedQuery<AuditActivity[]> =
    auditTimeline.status === 'ready'
      ? { status: 'ready', data: auditActivities }
      : auditTimeline;

  const breadcrumbItems = [
    'BITE DB',
    supplier?.type === 'products' ? 'Products' : 'Entities',
    supplier?.name || 'Entity',
    'Relationships',
  ];

  const entityMeta = [supplier?.category, supplier?.subcategory]
    .filter(Boolean)
    .join(' - ');

  const linkedEntityCount = relatedEntities.length;
  const showRelationships = supplier?.type !== 'products';

  const closeRelationshipRemovalModal = () => {
    if (deleteEntityRelationshipMutation.isPending) {
      return;
    }

    setPendingRelationshipRemoval(null);
  };

  const confirmRelationshipRemoval = async () => {
    if (!pendingRelationshipRemoval) {
      return;
    }

    const { relationshipId, relatedEntityId } = pendingRelationshipRemoval;
    setDeletingRelationshipId(relationshipId);

    try {
      await deleteEntityRelationshipMutation.mutateAsync(relationshipId);
      enqueueSnackbar('Relationship removed successfully', {
        variant: 'success',
      });

      queryClient.invalidateQueries({ queryKey: ['audit'] });
      queryClient.invalidateQueries({ queryKey: ['comment'] });

      if (activeEntityId === relatedEntityId) {
        setSelectedEntityId(initialEntityId ?? null);
        setCurrentAuditPage(1);
      }

      setPendingRelationshipRemoval(null);
    } catch (error: any) {
      enqueueSnackbar(error?.message || 'Failed to remove relationship', {
        variant: 'error',
      });
    } finally {
      setDeletingRelationshipId(null);
    }
  };

  const handleRemoveRelationship = (
    relationshipId: string,
    relatedEntityId: string,
    relatedEntityName?: string,
  ) => {
    if (!relationshipId || deleteEntityRelationshipMutation.isPending) {
      return;
    }

    setPendingRelationshipRemoval({
      relationshipId: relationshipId,
      relatedEntityId: relatedEntityId,
      relatedEntityName: relatedEntityName,
    });
  };

  const handleGoToScreeningResults = () => {
    selectSection('screening');
    if (activePanel === 'screening') {
      screeningResultsRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
      return;
    }

    shouldScrollToScreeningRef.current = true;
    setActivePanel('screening');
  };

  const handleResultsSourceChange = useCallback(
    (source: ResultSource) => {
      setTab(source);
      setCurrentPage(1);
      setOwnershipPage(0);
      const searchParams = new URLSearchParams(history.location.search);
      searchParams.set('tab', source === 'ownership' ? 'Ownership' : 'All');
      searchParams.set('page', '1');
      history.replace({
        pathname: history.location.pathname,
        search: `?${searchParams.toString()}`,
      });
    },
    [history],
  );

  // The results table sits on the Screening Results tab; switch to it first,
  // then scroll once it has rendered.
  const scrollToResultsTable = () => {
    window.setTimeout(() => {
      resultsTableRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }, 0);
  };

  const handleViewOwnershipResults = () => {
    setOwnershipPage(0);
    handleResultsSourceChange('ownership');
    selectSection('screening');
    scrollToResultsTable();
  };

  const handleViewAllMatches = () => {
    handleResultsSourceChange('all');
    selectSection('screening');
    scrollToResultsTable();
  };

  const handleRunEntityScreening = () => {
    if (!supplier?.database_id) {
      enqueueSnackbar('Database ID not found', { variant: 'error' });
      return;
    }

    const payload = {
      databaseId: supplier.database_id,
      databaseEntityId:
        supplier?.association_id ??
        supplier?.database_entity_id ??
        supplier?.database_product_id ??
        undefined,
      entityId:
        supplier?.entity_id ??
        supplier?.product_id ??
        supplier?.id ??
        undefined,
      initiatedBy: cur_user?.basics?.id,
    };

    enqueueSnackbar('Starting screening...', { variant: 'info' });
    if (payload.databaseEntityId || payload.entityId) {
      runEntityScreeningMutation.mutate(payload, {
        onSuccess: (response) => {
          const successes = Array.isArray(response?.result?.results)
            ? response.result.results.filter((result: any) => result.success)
            : null;
          const hasSuccess = successes ? successes.length > 0 : true;
          enqueueSnackbar(
            hasSuccess
              ? 'Screening started successfully'
              : 'Screening request accepted with warnings',
            { variant: hasSuccess ? 'success' : 'warning' },
          );
        },
        onError: (error: any) => {
          enqueueSnackbar(
            error?.response?.data?.message || 'Failed to start screening',
            { variant: 'error' },
          );
        },
      });
      return;
    }

    runScreeningMutation.mutate(
      { databaseIds: [supplier.database_id] },
      {
        onSuccess: () => {
          enqueueSnackbar('Screening started successfully', {
            variant: 'success',
          });
        },
        onError: (error: any) => {
          enqueueSnackbar(
            error?.response?.data?.message || 'Failed to start screening',
            { variant: 'error' },
          );
        },
      },
    );
  };

  const openEntityHubDrawer = (
    drawer: 'details' | 'hierarchy' | 'comments' | 'activity',
  ) => {
    setEntityHubDrawer(drawer);
    if (drawer === 'comments') {
      setActivePanel('comments');
    } else if (drawer === 'activity') {
      setActivePanel('audit');
    }
  };

  const closeEntityHubDrawer = () => {
    setEntityHubDrawer(null);
    setActivePanel('screening');
  };

  const statusLabel =
    (
      {
        approved: 'Cleared',
        cleared: 'Cleared',
        review: 'Needs review',
        needs_review: 'Needs review',
        not_reviewed: 'Not reviewed',
        quarantined: 'Quarantined',
        barred: 'Barred',
        rejected: 'Blocked',
        new: 'New',
      } as Record<string, string>
    )[String(currentStatusFlag).toLowerCase()] ||
    String(currentStatusFlag || 'New').replace(/_/g, ' ');
  const statusTone = ['approved', 'cleared'].includes(
    String(currentStatusFlag).toLowerCase(),
  )
    ? 'cleared'
    : ['rejected', 'blocked', 'barred', 'quarantined'].includes(
        String(currentStatusFlag).toLowerCase(),
      )
    ? 'blocked'
    : 'review';
  const formattedLastUpdated = (() => {
    const raw =
      supplier?.last_updated ||
      supplier?.updated_at ||
      screeningDate ||
      supplier?.created_at;
    if (!raw) return 'Not available';
    const date = new Date(raw);
    return Number.isNaN(date.getTime())
      ? String(raw)
      : date.toLocaleDateString('en-US', {
          month: 'short',
          day: 'numeric',
          year: 'numeric',
        });
  })();
  // The band's run is the same Verification Run as the verification page's,
  // keyed by entity so both views (and other tabs) see one run in flight.
  const verificationChecks = useMemo(
    () => buildEntityVerificationReportChecks(supplier || {}),
    [supplier],
  );
  const verificationLastRunAt = useMemo(
    () => latestVerificationRun(verificationChecks),
    [verificationChecks],
  );
  const refreshVerifiedRecord = useCallback(
    () => queryClient.invalidateQueries({ queryKey: entityKeys.all() }),
    [queryClient],
  );
  const verificationRun = useVerificationRun({
    supplier: supplier,
    entityKey: String(activeEntityId || initialEntityId || supplier?.id || ''),
    refetch: refreshVerifiedRecord,
  });
  // The team's Business Verification credits. Read again after each run (a run
  // uses credits); a failed read leaves the band neither showing nor blocking.
  const [verificationCredits, setVerificationCredits] = useState<{
    total: number;
    remaining: number;
  } | null>(null);
  useEffect(() => {
    const teamId = cur_user?.selected_team?.id;
    if (!teamId || !cur_user?.hasEntityAddon || verificationRun.running) {
      return undefined;
    }
    let cancelled = false;
    CreditsAPI.getVerificationCreditsSummary(String(teamId)).then(
      (response: any) => {
        if (cancelled) return;
        setVerificationCredits(
          response?.success
            ? {
                total: Number(response.result?.verification_credits ?? 0),
                remaining: Number(response.result?.remaining ?? 0),
              }
            : null,
        );
      },
    );
    return () => {
      cancelled = true;
    };
  }, [
    cur_user?.selected_team?.id,
    cur_user?.hasEntityAddon,
    verificationRun.running,
  ]);
  const verificationOnPlan =
    Boolean(cur_user?.hasEntityAddon) &&
    verificationRun.refusal !== 'addon-required';
  const verificationBlockedReason =
    databaseInfoResponse?.entity_add_on_enabled === false ||
    verificationRun.refusal === 'database-off'
      ? 'database-off'
      : null;
  // Screening never re-runs a check that already has a stored result (ADR 0004
  // in biteservices), so a re-screen only reads as "Verifying" for a record
  // with no results yet. A record that has results keeps showing them; any
  // check screening newly runs lands on the refresh when screening finishes.
  const screeningVerifyingRecord =
    screeningStatus?.verificationInProgress === true &&
    !hasVerificationResults(verificationChecks);
  // The band reads the verification page's own state and wording, so the
  // record page and the verification page always describe a record alike.
  // A Team without the Entity add-on, or one the service refuses because its
  // add-on flag is stale, still gets the Business Verification tab: its band
  // shows the plan state with a way to contact sales, and no run or report.
  // The database gate is shown through blockedReason.
  const verificationState = resolveVerificationPageState({
    supplier: supplier,
    checks: verificationChecks,
    hasPlan: verificationOnPlan,
    databaseVerificationOn: verificationBlockedReason !== 'database-off',
    running: verificationRun.running || screeningVerifyingRecord,
  });
  const verificationDescription = describeVerificationResult({
    state: verificationState,
    supplier: supplier,
    checks: verificationChecks,
    databaseName:
      supplier?.database_name || databaseInfoResponse?.name || 'this database',
  });
  // Business Verification is part of the Entity add-on. Teams without it still
  // see the tab, in its plan state; only the header's Verified pill needs it.
  const hasEntityAddon = Boolean(cur_user?.hasEntityAddon);
  const verificationReportPath = `/supplier/${
    activeEntityId || initialEntityId
  }/verification`;
  const ownershipTotal = Number(
    ownershipMatchesResponse?.result?.total_hits ??
      ownershipInfo?.matches?.length ??
      0,
  );

  // --- Status tabs: each says what is waiting behind it ---------------------
  const showSectionTabs = isEntityRecord;
  const activeSection: EntityHubSection = section;
  // The verdict boxes wait while a screen reads matches, not while it verifies.
  const isEvaluatingMatches =
    isEntityRecord &&
    Boolean(screeningStatus?.inProgress || screeningStatus?.aiInProgress);
  const verificationStartedAtMs = verificationRun.runStartedAt
    ? verificationRun.runStartedAt
    : screeningStatus?.run?.startedAt
    ? new Date(screeningStatus.run.startedAt).getTime()
    : NaN;
  const verificationElapsed = useSecondsSince(
    verificationStartedAtMs,
    verificationState === 'running',
  );
  // Beneficial Ownership runs for every entity type, people included.
  const investigation = useOwnershipInvestigation({
    enabled: isEntityRecord,
    name: supplier?.name,
    country: supplier?.country_of_origin,
    aliases: supplier?.alias,
    address: supplier?.address,
    registrationNumber: supplier?.business_registration_number,
    domain: supplier?.domain,
    parentBusiness: supplier?.parent_business,
    databaseId: supplier?.database_id,
    databaseEntityId: ownershipEntityId,
    entityId: supplier?.entity_id ?? supplier?.id,
    onReportFiled: library.reload,
  });
  // The Deep Dive's Beneficial Ownership report downloads from the record's
  // Export menu, once a run has left a report to read.
  const ownershipReportReady = canReadOwnershipReport(investigation);
  const [isDownloadingOwnershipReport, setIsDownloadingOwnershipReport] =
    useState(false);
  const handleDownloadOwnershipReport = useCallback(async () => {
    const recordDatabaseId = supplier?.database_id
      ? String(supplier.database_id)
      : '';
    if (
      isDownloadingOwnershipReport ||
      !investigation.ticketId ||
      !recordDatabaseId ||
      !ownershipEntityId
    ) {
      return;
    }
    setIsDownloadingOwnershipReport(true);
    try {
      await downloadOwnershipReportPdf(
        recordDatabaseId,
        String(ownershipEntityId),
        investigation.ticketId,
      );
    } catch (error: any) {
      enqueueSnackbar(
        `Failed to generate the Beneficial Ownership report: ${
          error?.message || 'Unknown error'
        }`,
        { variant: 'error' },
      );
    } finally {
      setIsDownloadingOwnershipReport(false);
    }
  }, [
    investigation.ticketId,
    isDownloadingOwnershipReport,
    ownershipEntityId,
    supplier?.database_id,
  ]);
  // Deep Dive: Export and Transshipment Risk, the entity service's risk agents
  // run in parallel and combined (business-checks/evaluate-entity-risk).
  // Each agent saves its result to the record, which reads it back.
  const risk = useEntityRiskEvaluation({
    record: supplier,
    recordKey: String(ownershipEntityId ?? supplier?.id ?? ''),
    name: supplier?.name,
    country: supplier?.country_of_origin,
    address: supplier?.address,
    statedBusiness: entityMeta,
    aliases: Array.isArray(supplier?.aliases) ? supplier.aliases : undefined,
    databaseId: supplier?.database_id,
    databaseEntityId: ownershipEntityId,
    entityId: supplier?.entity_id ?? supplier?.id,
    onSaved: refreshVerifiedRecord,
    onReportFiled: library.reload,
  });
  // Export and Transshipment Risk's report downloads from the record's Export
  // menu, once a run has left a result to read.
  const riskReportReady = risk.state === 'done' && Boolean(risk.evaluation);
  const [isDownloadingRiskReport, setIsDownloadingRiskReport] =
    useState(false);
  const handleDownloadRiskReport = useCallback(async () => {
    if (isDownloadingRiskReport || !risk.evaluation) {
      return;
    }
    const preparedBy =
      [cur_user?.basics?.firstName, cur_user?.basics?.lastName]
        .filter(Boolean)
        .join(' ')
        .trim() ||
      cur_user?.basics?.email ||
      'BITE Entity Screening';
    setIsDownloadingRiskReport(true);
    try {
      await downloadEntityRiskReportPdf({
        evaluation: risk.evaluation,
        entityName: supplier?.name || '',
        country: supplier?.country_of_origin,
        preparedBy: preparedBy,
      });
    } catch (error: any) {
      enqueueSnackbar(
        `Failed to generate the Export and Transshipment Risk report: ${
          error?.message || 'Unknown error'
        }`,
        { variant: 'error' },
      );
    } finally {
      setIsDownloadingRiskReport(false);
    }
  }, [
    cur_user?.basics?.email,
    cur_user?.basics?.firstName,
    cur_user?.basics?.lastName,
    isDownloadingRiskReport,
    risk.evaluation,
    supplier?.country_of_origin,
    supplier?.name,
  ]);
  const riskElapsed =
    useSecondsSince(risk.startedAt, risk.state === 'running') ?? 0;
  const investigationElapsed =
    useSecondsSince(
      investigation.startedAt,
      investigation.state === 'running',
    ) ?? 0;
  const canRunOwnership = Boolean(
    beneficialOwnershipEnabled &&
      supplier?.database_id &&
      ownershipEntityId &&
      !evaluateOwnershipMutation.isPending,
  );
  const sectionTabs: EntityHubStatusTab[] = [
    {
      key: 'screening',
      label: 'Screening Results',
      status: screeningSectionStatus({
        screening: isEvaluatingMatches,
        hasEvaluation: aiHasEvaluation,
        risk: aiHasEvaluation ? aiRiskLabel : '',
        // Every match behind the tab: watchlist hits plus, when the database
        // runs it, the beneficial ownership hits.
        matchCount:
          screeningResultsTotal +
          (beneficialOwnershipEnabled ? ownershipTotal : 0),
      }),
    },
    {
      key: 'verification',
      label: 'Business Verification',
      status: verificationSectionStatus(
        verificationState,
        verificationDescription,
        verificationElapsed,
        verificationChecks.length,
      ),
    },
    {
      key: 'deep-dive',
      label: 'Deep Dive',
      status: deepDiveSectionStatus([
        investigationTool(
          investigation.state,
          investigationElapsed,
          investigation.finishedHere,
        ),
        {
          name: 'Export and Transshipment Risk',
          state:
            risk.state === 'done' && risk.evaluation?.failed
              ? 'attention'
              : risk.state,
          elapsedSeconds: riskElapsed,
          finishedHere: risk.finishedHere,
        },
      ]),
    },
  ];
  const panelProps = (key: EntityHubSection) =>
    showSectionTabs
      ? {
          role: 'tabpanel',
          id: sectionPanelId(key),
          'aria-labelledby': sectionTabId(key),
          hidden: activeSection !== key,
        }
      : {};

  return (
    <div className='team-content-container relationship-explorer entity-hub-detail'>
      <section className='entity-hub-record-header'>
        <div className='entity-hub-record-main'>
          <div className='entity-hub-record-identity'>
            <span className='entity-hub-record-icon' aria-hidden='true'>
              {supplier?.type === 'products' ? (
                <Inventory2OutlinedIcon />
              ) : (
                <ApartmentOutlinedIcon />
              )}
            </span>
            <div className='entity-hub-record-copy'>
              <div className='entity-hub-record-title-line'>
                <h1>{supplier?.name || 'Entity'}</h1>
                <span className={`entity-hub-status ${statusTone}`}>
                  <span aria-hidden='true' />
                  {statusLabel}
                </span>
                {hasEntityAddon && verificationState === 'clean' ? (
                  <span className='entity-hub-status verified'>
                    <span aria-hidden='true'>✓</span>
                    Verified · {verificationDescription.figure}
                  </span>
                ) : null}
                {isEntityRecord && isScreeningCurrently ? (
                  <span className='entity-hub-status screening'>
                    <span aria-hidden='true' />
                    {isScreeningDelayed
                      ? DELAYED_SCREENING_MESSAGE
                      : 'Screening in progress'}
                  </span>
                ) : null}
              </div>
              <p>
                {[entityMeta, supplier?.country_of_origin]
                  .filter(Boolean)
                  .join('  |  ') || 'Entity record'}
              </p>
            </div>
          </div>

          <div className='entity-hub-record-actions'>
            <button
              type='button'
              className='entity-hub-btn primary'
              onClick={handleRunEntityScreening}
              disabled={
                runScreeningMutation.isPending ||
                runEntityScreeningMutation.isPending
              }
            >
              <SearchOutlinedIcon />
              {runScreeningMutation.isPending ||
              runEntityScreeningMutation.isPending
                ? 'Running...'
                : 'Run Screen'}
            </button>
            <button
              type='button'
              className='entity-hub-btn'
              onClick={() => setIsChangeStatusModalOpen(true)}
            >
              Change Status
              <EditOutlinedIcon />
            </button>
            <div className='entity-hub-export-wrap'>
              <button
                type='button'
                className='entity-hub-btn'
                onClick={() => setIsExportMenuOpen((open) => !open)}
                aria-expanded={isExportMenuOpen}
              >
                <DownloadOutlinedIcon />
                Export
                <KeyboardArrowDownOutlinedIcon />
              </button>
              {isExportMenuOpen ? (
                <div className='entity-hub-export-menu'>
                  <button
                    type='button'
                    disabled={isDownloadingEntityReport}
                    onClick={() => {
                      setIsExportMenuOpen(false);
                      handleDownloadEntityReport();
                    }}
                  >
                    <DescriptionOutlinedIcon />
                    <span>
                      <strong>
                        {isDownloadingEntityReport
                          ? 'Preparing PDF report'
                          : 'PDF report'}
                      </strong>
                      <small>
                        {isDownloadingEntityReport
                          ? 'The download will start when ready'
                          : 'The whole record as a document'}
                      </small>
                    </span>
                  </button>
                  {ownershipReportReady ? (
                    <button
                      type='button'
                      disabled={isDownloadingOwnershipReport}
                      onClick={() => {
                        setIsExportMenuOpen(false);
                        handleDownloadOwnershipReport();
                      }}
                    >
                      <GroupsOutlinedIcon />
                      <span>
                        <strong>
                          {isDownloadingOwnershipReport
                            ? 'Preparing Beneficial Ownership report'
                            : 'Beneficial Ownership report'}
                        </strong>
                        <small>
                          {isDownloadingOwnershipReport
                            ? 'The download will start when ready'
                            : 'The Deep Dive investigation as a PDF'}
                        </small>
                      </span>
                    </button>
                  ) : null}
                  {riskReportReady ? (
                    <button
                      type='button'
                      disabled={isDownloadingRiskReport}
                      onClick={() => {
                        setIsExportMenuOpen(false);
                        handleDownloadRiskReport();
                      }}
                    >
                      <LocalShippingOutlinedIcon />
                      <span>
                        <strong>
                          {isDownloadingRiskReport
                            ? 'Preparing Export and Transshipment Risk report'
                            : 'Export and Transshipment Risk report'}
                        </strong>
                        <small>
                          {isDownloadingRiskReport
                            ? 'The download will start when ready'
                            : 'The Deep Dive risk run as a PDF'}
                        </small>
                      </span>
                    </button>
                  ) : null}
                  <button
                    type='button'
                    disabled={isStartingMatchesCsv || Boolean(matchesCsvJobId)}
                    onClick={() => {
                      setIsExportMenuOpen(false);
                      handleDownloadMatchesCsv();
                    }}
                  >
                    <DownloadOutlinedIcon />
                    <span>
                      <strong>
                        {isStartingMatchesCsv || matchesCsvJobId
                          ? 'Preparing matches — CSV'
                          : 'Matches — CSV'}
                      </strong>
                      <small>
                        {isStartingMatchesCsv || matchesCsvJobId
                          ? 'Downloads automatically when ready'
                          : 'One row per list match'}
                      </small>
                    </span>
                  </button>
                  <div className='entity-hub-export-note'>
                    Exports all screening matches for this entity.
                  </div>
                </div>
              ) : null}
            </div>
            <button
              type='button'
              className='entity-hub-icon-btn'
              aria-label='Share entity'
              onClick={() => setShareShowModalOpen(true)}
            >
              <ShareOutlinedIcon />
            </button>
            <button
              type='button'
              className='entity-hub-icon-btn quiet'
              aria-label='Open help'
              onClick={() => setHelpModalOpen(true)}
            >
              <HelpOutlineOutlinedIcon />
            </button>
          </div>
        </div>

        <div className='entity-hub-record-nav'>
          <div>
            <button
              type='button'
              onClick={() => openEntityHubDrawer('details')}
            >
              <DescriptionOutlinedIcon />
              Details
            </button>
            <button
              type='button'
              onClick={() => openEntityHubDrawer('hierarchy')}
            >
              <AccountTreeOutlinedIcon />
              Hierarchy
              <span>{linkedEntityCount}</span>
            </button>
          </div>
          <p>
            <AccessTimeOutlinedIcon /> Last updated
            <strong>{formattedLastUpdated}</strong>
          </p>
        </div>
      </section>

      {showSectionTabs ? (
        <EntityHubStatusTabs
          tabs={sectionTabs}
          active={activeSection}
          onSelect={selectSection}
        />
      ) : null}

      <HelpContentModal
        isOpen={helpModalOpen}
        setIsOpen={setHelpModalOpen}
        title={helpContent?.title || 'Help'}
        description={helpContent?.description}
        helpItems={helpContent?.helpItems || []}
      />

      <div
        className='relationship-explorer-tabs'
        ref={screeningResultsRef}
        {...panelProps('screening')}
      >
        <div className='relationship-tab-body'>
          <div className='relationship-tab-panel relationship-screening-panel'>
            <EntityHubVerdictBoxes
              entityName={supplier?.name || ''}
              sanctions={{
                evaluating: isEvaluatingMatches,
                hasEvaluation: aiHasEvaluation,
                risk: aiRiskLabel,
                explanation: aiExplanation,
                topMatches: aiTopMatches,
                screenDate:
                  aiSummary?.screenDate && aiSummary.screenDate !== '-'
                    ? aiSummary.screenDate
                    : undefined,
                matchCount: screeningResultsTotal,
              }}
              ownership={{
                enabled: beneficialOwnershipEnabled,
                settingLoading: beneficialOwnershipSettingLoading,
                running: evaluateOwnershipMutation.isPending,
                elapsed: ownershipCheckElapsed,
                done: hasDetailedOwnershipEvaluation,
                info: ownershipInfo,
                canRun: canRunOwnership,
              }}
              media={{
                running: isCheckingAdverseMedia,
                elapsed: adverseMediaCheckElapsed,
                data: adverseMediaData,
                canRun: Boolean(supplier?.name),
              }}
              onViewMatches={handleViewAllMatches}
              onRunOwnership={handleEvaluateOwnership}
              onViewOwnership={handleViewOwnershipResults}
              onOpenOwnershipSettings={handleOpenOwnershipSettings}
              onRunMedia={handleRunAdverseMedia}
            />

            <div className='entity-hub-results-title-row' ref={resultsTableRef}>
              {/* The Screening Results tab names this table already. */}
              {showSectionTabs ? null : <h2>Screening Results</h2>}
            </div>

            <BiteDBEntityScreeningResults
              key={String(ownershipEntityId ?? '')}
              allMatchesCount={screeningResultsTotal}
              ownershipResponse={ownershipMatchesResponse}
              ownershipLoading={isOwnershipMatchesLoading}
              ownershipPage={ownershipPage}
              setOwnershipPage={setOwnershipPage}
              ownershipSnapshot={ownershipInfo}
              ownershipEnabled={beneficialOwnershipEnabled}
              ownershipSettingLoading={beneficialOwnershipSettingLoading}
              onOpenSettings={handleOpenOwnershipSettings}
              entityName={supplier?.name || ''}
              onAllSearchChange={() => setCurrentPage(1)}
              activeSource={tab}
              onSourceChange={handleResultsSourceChange}
              toolbarTrailingActions={
                !isProductRecord ? (
                  <div className='entity-hub-results-meta-actions'>
                    <button
                      type='button'
                      onClick={() => openEntityHubDrawer('comments')}
                    >
                      <CommentOutlinedIcon />
                      Comments
                      <span>
                        {Array.isArray(comments) ? comments.length : 0}
                      </span>
                    </button>
                    <button
                      type='button'
                      onClick={() => openEntityHubDrawer('activity')}
                    >
                      <AccessTimeOutlinedIcon />
                      Activity
                      {entityActivityCount !== null ? (
                        <span>{entityActivityCount}</span>
                      ) : null}
                    </button>
                  </div>
                ) : null
              }
              renderAllMatches={(
                resultsSearchQuery,
                _hideToolbar,
                onResultCountChange,
                actionsPortalTarget,
              ) => (
                <BiteDBAllMatchesTable
                  passedDownResults={passedDownResults}
                  hitTotal={screeningResultsTotal}
                  entityName={supplier?.name || ''}
                  isLoading={
                    isLoading ||
                    isSavingDetails ||
                    (!isEntityRecord && isScreeningCurrently)
                  }
                  searchQuery={resultsSearchQuery}
                  actionsPortalTarget={actionsPortalTarget}
                  onResultCountChange={onResultCountChange}
                  onToggleHitVisibility={removeHit}
                  removedHitIds={removedDocIds}
                  databaseId={
                    supplier?.database_id || initialSupplier?.database_id
                  }
                  databaseName={
                    supplier?.database_name || initialSupplier?.database_name
                  }
                  entityId={sourceEntityId}
                  groupId={cur_user?.selected_team?.id}
                  canAccessVerificationResults={Boolean(
                    cur_user?.hasEntityAddon,
                  )}
                  suppliersData={supplier}
                  buildEntityScreeningReport={buildEntityScreeningReport}
                  bulkSelectedHits={bulkSelectedHits}
                  setBulkSelectedHits={setBulkSelectedHits}
                  parentDatabaseEntityId={activeDatabaseEntityId}
                  parentEntityName={supplier?.name}
                  onBulkUpdateHits={handleBulkUpdateHits}
                  isBulkHiding={
                    bulkHideEntityHitsMutation.isPending ||
                    bulkUnhideEntityHitsMutation.isPending
                  }
                />
              )}
            />
          </div>
          {!isProductRecord && (
            <AuditLogFilterModal
              open={showAuditFilterModal}
              onClose={() => setShowAuditFilterModal(false)}
              availableActions={auditFilterActions}
              noActionsMessage={
                auditFilterActionsFailed
                  ? 'Could not load action types.'
                  : 'No actions recorded yet for this entity.'
              }
              availablePeople={auditFilterPeople}
              noPeopleMessage={
                auditFilterPeopleFailed
                  ? 'Could not load people.'
                  : 'No one has recorded activity on this entity yet.'
              }
              filters={auditFilters}
              onApply={(nextFilters) => setAuditFilters(nextFilters)}
            />
          )}
        </div>
      </div>

      {showSectionTabs ? (
        <div
          className='entity-hub-section-panel'
          {...panelProps('verification')}
        >
          <EntityVerificationBand
            state={verificationState}
            summary={verificationDescription}
            entityName={supplier?.name || 'this entity'}
            startedAt={
              verificationRun.runStartedAt
                ? new Date(verificationRun.runStartedAt).toISOString()
                : screeningStatus?.run?.startedAt
            }
            runDisabled={verificationRun.running}
            runBlockedReason={verificationRunBlockedReason({
              credits: verificationCredits,
              databaseScreening: verificationRun.databaseScreening,
            })}
            credits={verificationCredits}
            blockedReason={verificationBlockedReason}
            showWhenClean
            onRequestRun={verificationRun.run}
            onFullReport={() => history.push(verificationReportPath)}
          />
          {supplier && verificationState !== 'noplan' ? (
            <EntityVerificationReportView
              embedded
              supplier={supplier}
              databaseName={
                supplier?.database_name ||
                databaseInfoResponse?.name ||
                'this database'
              }
              databaseId={rootDatabaseId || undefined}
              checks={verificationChecks}
              lastRunAt={verificationLastRunAt}
              databaseVerificationOn={
                verificationBlockedReason !== 'database-off'
              }
              running={verificationState === 'running'}
              runStartedAt={
                Number.isFinite(verificationStartedAtMs)
                  ? verificationStartedAtMs
                  : null
              }
              onEditDetails={() => openEntityHubDrawer('details')}
              onRun={verificationRun.run}
            />
          ) : null}
        </div>
      ) : null}

      {showSectionTabs ? (
        <div className='entity-hub-section-panel' {...panelProps('deep-dive')}>
          <EntityHubDeepDive
            entityName={supplier?.name || ''}
            entityCountry={supplier?.country_of_origin}
            investigation={investigation}
            investigationElapsedSeconds={investigationElapsed}
            library={library}
            currentUserId={cur_user?.basics?.id}
            canManageDocuments={
              cur_user?.role === 'owner' || cur_user?.role === 'admin'
            }
            risk={risk}
            riskElapsedSeconds={riskElapsed}
          />
        </div>
      ) : null}

      <Drawer
        anchor='right'
        open={Boolean(entityHubDrawer)}
        onClose={closeEntityHubDrawer}
        PaperProps={{ className: 'entity-hub-drawer-paper' }}
        ModalProps={{
          BackdropProps: { className: 'entity-hub-drawer-backdrop' },
        }}
      >
        <div className='entity-hub-drawer-header'>
          <span className='entity-hub-drawer-heading-icon' aria-hidden='true'>
            {entityHubDrawer === 'details' ? (
              <DescriptionOutlinedIcon />
            ) : entityHubDrawer === 'hierarchy' ? (
              <AccountTreeOutlinedIcon />
            ) : entityHubDrawer === 'comments' ? (
              <CommentOutlinedIcon />
            ) : (
              <AccessTimeOutlinedIcon />
            )}
          </span>
          <div>
            <h2>
              {entityHubDrawer === 'details'
                ? 'Entity Details'
                : entityHubDrawer === 'hierarchy'
                ? 'Entity Hierarchy'
                : entityHubDrawer === 'comments'
                ? 'Comments'
                : 'Activity'}
            </h2>
            <p>
              {entityHubDrawer === 'details'
                ? `Identity, registration and contact information for ${
                    supplier?.name || 'this entity'
                  }.`
                : entityHubDrawer === 'hierarchy'
                ? 'Explore and manage the relationships connected to this record.'
                : entityHubDrawer === 'comments'
                ? 'Visible to everyone on your team'
                : 'Everything that has happened to this record'}
            </p>
          </div>
          <button
            type='button'
            aria-label='Close drawer'
            onClick={closeEntityHubDrawer}
          >
            <CloseOutlinedIcon />
          </button>
        </div>
        <div
          className={`entity-hub-drawer-body entity-hub-drawer-body-${
            entityHubDrawer || 'closed'
          }`}
        >
          {entityHubDrawer === 'details' ? (
            <RelationshipDetailsPanel
              supplier={supplier}
              detailsCardRef={detailsCardRef}
              isEditingDetails={isEditingDetails}
              isSavingDetails={isSavingDetails}
              onDetailsCancel={handleDetailsCancel}
              onDetailsSave={handleDetailsSave}
              onEditStateChange={setIsEditingDetails}
              onSavingChange={setIsSavingDetails}
              linkedEntityCount={linkedEntityCount}
              linkedEntityGroups={linkedEntityGroups}
              formatRelationshipTypeLabel={formatRelationshipTypeLabel}
              onGoToScreeningResults={() => {
                closeEntityHubDrawer();
                window.setTimeout(handleGoToScreeningResults, 0);
              }}
            />
          ) : entityHubDrawer === 'hierarchy' ? (
            <RelationshipHierarchyPanel
              rootEntity={initialSupplier}
              hierarchyData={entityHierarchyData}
              relationshipEdges={rootEntityRelationships}
              isLoadingHierarchy={isLoadingHierarchy}
              hierarchyError={entityHierarchyError}
              selectedEntityId={activeEntityId ?? null}
              showRelationships={showRelationships}
              onAddRelationship={() => setIsRelationshipModalOpen(true)}
              onSelectEntity={(entityId) => {
                setSelectedEntityId(entityId);
                setCurrentAuditPage(1);
                setCurrentPage(1);
              }}
              onRemoveRelationship={handleRemoveRelationship}
              deletingRelationshipId={deletingRelationshipId}
            />
          ) : entityHubDrawer === 'comments' ? (
            <Comments
              comments={comments}
              setCommentContent={setCommentContent}
              handleAddComment={handleAddComment}
              handleDeleteComment={handleDeleteComment}
              cur_user={cur_user}
              getDateDifference={getDateDifference}
              isLoadingComments={isLoadingComments}
              commentContent={commentContent}
              appearance='entity-hub'
            />
          ) : entityHubDrawer === 'activity' ? (
            <AuditLogPanel
              state={auditPanelState}
              emptyMessage={
                isProductRecord
                  ? 'No audit logs found'
                  : 'No activity recorded for this entity yet.'
              }
              idleMessage={
                !isProductRecord && supplier && !auditEntityRef
                  ? 'Activity is unavailable for this record: it is not linked to a database.'
                  : undefined
              }
              widerScopeLabel='View full database activity'
              onViewWiderScope={
                !isProductRecord && supplier?.database_id
                  ? () =>
                      history.push({
                        pathname: `/database/${supplier.database_id}`,
                        search: `?tab=${encodeURIComponent(
                          'Screening History',
                        )}`,
                      })
                  : undefined
              }
              currentPage={currentAuditPage}
              totalPages={totalAuditPages}
              onPrevPage={handlePrevAuditPage}
              onNextPage={handleNextAuditPage}
              onJumpToPage={setCurrentAuditPage}
              searchValue={!isProductRecord ? auditSearchInput : undefined}
              onSearchChange={
                !isProductRecord ? setAuditSearchInput : undefined
              }
              hasActiveFilters={hasActiveAuditFilters}
              onOpenFilters={
                !isProductRecord
                  ? () => setShowAuditFilterModal(true)
                  : undefined
              }
              filterChips={!isProductRecord ? auditFilterChips : undefined}
              onClearFilters={!isProductRecord ? clearAuditFilters : undefined}
              appearance='entity-hub'
            />
          ) : null}
        </div>
      </Drawer>

      <AddEntityRelationshipModal
        isOpen={isRelationshipModalOpen}
        onClose={() => setIsRelationshipModalOpen(false)}
        sourceEntityId={sourceEntityId}
        sourceEntityName={supplier?.name}
        sourceDatabaseId={supplier?.database_id || initialSupplier?.database_id}
        sourceDatabaseName={
          supplier?.database_name || initialSupplier?.database_name
        }
        existingRelationships={entityRelationships}
        isLoadingExistingRelationships={isLoadingRelationships}
        onSuccess={() => setTrigger(!trigger)}
      />

      <LinkProductSupplierModal
        isOpen={openLinkModal}
        onClose={() => setOpenLinkModal(false)}
        onSuccess={() => {
          setTrigger(!trigger);
          return;
        }}
        type={supplier && supplier.type === 'supplier' ? 'supplier' : 'product'}
        selected={supplier}
      />

      {shareModalOpen && (
        <Formik
          initialValues={{
            sharedWith: [],
            status: 'draft',
          }}
          onSubmit={(values) => {
            // TODO
          }}
        >
          {({ values, setFieldValue, submitForm }) => (
            <Form>
              <Modal
                open={shareModalOpen}
                onClose={() => {
                  setShareShowModalOpen(false);
                }}
              >
                <ShareModal
                  userOpts={userOpts}
                  submitForm={submitForm}
                  setShareOpen={setShareShowModalOpen}
                  onSuccess={() => {
                    setTrigger(!trigger);
                    return;
                  }}
                  type={
                    supplier && supplier.type === 'supplier'
                      ? 'supplier'
                      : 'product'
                  }
                  curUser={cur_user}
                  itemId={supplier ? supplier.id : ''}
                  item={supplier}
                  values={values}
                  setFieldValue={setFieldValue}
                />
              </Modal>
            </Form>
          )}
        </Formik>
      )}

      {/* Change Status Modal */}
      <Modal
        open={isChangeStatusModalOpen}
        onClose={() => setIsChangeStatusModalOpen(false)}
      >
        <ChangeStatus
          isChangingStatus={isChangingStatus}
          handleClose={() => setIsChangeStatusModalOpen(false)}
          changeStatus={handleStatusUpdate}
          curStatus={currentStatusFlag}
        />
      </Modal>
      <Modal
        open={Boolean(pendingRelationshipRemoval)}
        onClose={closeRelationshipRemovalModal}
      >
        <ConfirmRelationshipRemovalModal
          description={
            pendingRelationshipRemoval?.relatedEntityName
              ? `This will remove the relationship to ${pendingRelationshipRemoval.relatedEntityName}.`
              : 'This will remove this relationship.'
          }
          onCancel={closeRelationshipRemovalModal}
          onConfirm={confirmRelationshipRemoval}
          isProcessing={deleteEntityRelationshipMutation.isPending}
        />
      </Modal>
    </div>
  );
};

export default Results;
